// Batalkan Pekerjaan Bordir (Shopee/Tokopedia & Offline): alasan wajib, pcs terkerjakan, konfirmasi 2 langkah.
import { useState } from "react";

export const BORDIR_CANCEL_REASONS = [["mesin", "Mesin Bermasalah"], ["bahan", "Bahan Bermasalah"], ["salah_ambil", "Salah Ambil Pekerjaan"], ["lainnya", "Lainnya"]];

export function bordirCancelValid({ reason, note, pcs }, maxPcs) {
  if (!BORDIR_CANCEL_REASONS.some(([k]) => k === reason)) return "Pilih alasan pembatalan";
  if (reason === "lainnya" && (note || "").trim().length < 3) return "Alasan 'Lainnya' wajib diberi keterangan";
  const n = Number(pcs);
  if (pcs === "" || !Number.isInteger(n) || n < 0) return "Isi jumlah pcs yang sudah dibordir (0 bila belum ada)";
  if (maxPcs && n > maxPcs) return `Jumlah pcs maksimal ${maxPcs}`;
  return "";
}

export const priorProgressText = (p) => p ? `${p.pcs_done} pcs sudah dibordir oleh ${p.by} sebelum dibatalkan (${p.reason_label})` : "";

const box = { position: "fixed", inset: 0, background: "rgba(15,23,42,.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 };
// Tombol radio jangan ikut gaya input umum (lebar 100%/tinggi besar di HP)
const radioRow = { display: "flex", gap: 10, alignItems: "center", justifyContent: "flex-start", textAlign: "left", minHeight: 40, cursor: "pointer", fontSize: 15 };
const radioIn = { width: 20, height: 20, minWidth: 20, minHeight: 0, flex: "none", margin: 0, padding: 0 };
const card = { background: "#fff", borderRadius: 12, padding: 18, width: "min(420px, 92vw)", display: "grid", gap: 10 };

export function BordirCancelDialog({ label, maxPcs, onSubmit, onClose }) {
  const [f, setF] = useState({ reason: "", note: "", pcs: "" });
  const [step, setStep] = useState("form");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const invalid = bordirCancelValid(f, maxPcs);
  const reasonLabel = (BORDIR_CANCEL_REASONS.find(([k]) => k === f.reason) || [])[1];
  const submit = async () => {
    if (busy) return;
    setBusy(true); setErr("");
    try { await onSubmit({ reason: f.reason, note: f.note.trim(), pcs_done: Number(f.pcs) }); }
    catch (e) { setErr(e?.response?.data?.detail || e?.message || "Gagal membatalkan"); setStep("form"); }
    finally { setBusy(false); }
  };
  return <div style={box} onClick={e => { e.stopPropagation(); if (!busy) onClose(); }} data-testid="bordir-cancel-dialog">
    <div style={card} onClick={e => e.stopPropagation()}>
      <b style={{ fontSize: 16 }}>Batalkan Pekerjaan Bordir</b>
      <small style={{ color: "#475569" }}>{label}</small>
      {step === "form" ? <>
        <div style={{ display: "grid", gap: 6 }} role="radiogroup">
          {BORDIR_CANCEL_REASONS.map(([k, l]) => <label key={k} style={radioRow}>
            <input type="radio" name="bordir-cancel-reason" checked={f.reason === k} onChange={() => setF({ ...f, reason: k })} style={radioIn} data-testid={`bordir-cancel-reason-${k}`} /> <span>{l}</span>
          </label>)}
        </div>
        <textarea value={f.note} onChange={e => setF({ ...f, note: e.target.value })} maxLength={300} rows={2}
          placeholder={f.reason === "lainnya" ? "Keterangan (wajib)" : "Keterangan (opsional)"} data-testid="bordir-cancel-note" />
        <label style={{ fontSize: 13 }}>Jumlah pcs yang SUDAH dibordir{maxPcs ? ` (dari ${maxPcs})` : ""}
          <input type="number" min={0} max={maxPcs || undefined} value={f.pcs} onChange={e => setF({ ...f, pcs: e.target.value })}
            style={{ width: "100%", marginTop: 4 }} data-testid="bordir-cancel-pcs" /></label>
        {(err || (f.reason && invalid)) && <small style={{ color: "#b91c1c" }} data-testid="bordir-cancel-error">{err || invalid}</small>}
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button className="soft-btn small-btn" onClick={onClose} disabled={busy} data-testid="bordir-cancel-close">Kembali</button>
          <button className="primary small-btn" disabled={!!invalid} onClick={() => setStep("confirm")} data-testid="bordir-cancel-next">Lanjut</button>
        </div>
      </> : <>
        <div data-testid="bordir-cancel-confirm-text">Yakin membatalkan pekerjaan ini? Alasan: <b>{reasonLabel}</b> · <b>{Number(f.pcs)} pcs</b> sudah dibordir.
          Pekerjaan kembali ke antrean agar bisa diambil operator lain. Pesanan & mockup tidak dihapus, dan pekerjaan ini tidak dihitung selesai untuk Anda.</div>
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button className="soft-btn small-btn" onClick={() => setStep("form")} disabled={busy} data-testid="bordir-cancel-back">Ubah</button>
          <button className="primary small-btn" style={{ background: "#b91c1c" }} onClick={submit} disabled={busy} data-testid="bordir-cancel-confirm">
            {busy ? "Membatalkan…" : "Ya, Batalkan Pekerjaan"}</button>
        </div>
      </>}
    </div>
  </div>;
}
